import { Injectable, NgZone } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TimeZoneRetrieval {
  retrieveTimeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'UTC';
  }
}
